var displayResults = false;
var location = 'hireful';
let search = false;

function getLocation(form) {
	if (navigator.geolocation) {
		navigator.geolocation.getCurrentPosition(function (position) {
			addLgnLat(form, position.coords.latitude, position.coords.longitude);
			form.find('[name=search_term]').val(vp_search_vars.your_location);
			search = false;
		});
	} else {
		alert(vp_search_vars.geolocation_not_supported);
	}
}

function geocodeAddress(address, form, country) {
    return new Promise((resolve, reject) => {
        var geocoder = new google.maps.Geocoder();

        // Convert comma-separated country string to an array (uppercase for comparison)
        const allowedCountries = country
            ? country.split(',').map((c) => c.trim().toUpperCase())
            : [];

        function doGeocode(query) {
            geocoder.geocode(
                { address: query },
                function (results, status) {
                    if (status === 'OK' && results.length > 0) {
                        const filteredResults = results.filter((result) => {
                            const hasValidType =
                                result.types.includes('locality') ||
                                result.types.includes('postal_code') ||
                                result.types.includes('street_address') ||
                                result.types.includes('political') ||
                                result.types.includes('sublocality') ||
                                result.types.includes('administrative_area_level_1');

                            const isInAllowedCountry =
                                allowedCountries.length > 0
                                    ? result.address_components.some(
                                          (component) =>
                                              component.types.includes('country') &&
                                              allowedCountries.includes(component.short_name.toUpperCase())
                                      )
                                    : true;

                            return hasValidType && isInAllowedCountry;
                        });

                        if (filteredResults.length > 0) {
                            if (filteredResults.length === 1) {
                                const selectedResult = filteredResults[0];
                                const lat = selectedResult.geometry.location.lat();
                                const lng = selectedResult.geometry.location.lng();
                                console.log('Latitude:', lat);
                                console.log('Longitude:', lng);
                                addLgnLat(form, lat, lng);
                                resolve(filteredResults);
                            } else {
                                resolve(filteredResults);
                            }
                        } else {
							const ukAllowed = allowedCountries.includes('GB') || allowedCountries.includes('UK');
							if (ukAllowed && !query.toLowerCase().endsWith(' uk')) {
								console.log(`No results for "${query}", retrying with " UK" appended...`);
								doGeocode(query + ' UK');
							} else {
								addLgnLat(form, '', '');
								reject(new Error('No valid address-based results found within the specified countries.'));
							}
                        }
                    } else {
						const ukAllowed = allowedCountries.includes('GB') || allowedCountries.includes('UK');
						if (ukAllowed && !query.toLowerCase().endsWith(' uk')) {
							console.log(`No results for "${query}", retrying with " UK" appended...`);
							doGeocode(query + ' UK');
						} else {
							addLgnLat(form, '', '');
							reject(new Error('No valid address-based results found within the specified countries.'));
						}
                    }
                }
            );
        }

        doGeocode(address);
    });
}

function multipleLocations(locations) {
	jQuery('#multiple-locations').empty();

	locations.forEach((location, index) => {
		const formattedAddress = location.formatted_address;
		const lat = location.geometry.location.lat();
		const lng = location.geometry.location.lng();

		const locationDiv = jQuery(`
            <div class="location-item" data-lat="${lat}" data-lng="${lng}">${formattedAddress}</div>
        `);

		jQuery('#multiple-locations').append(locationDiv);
	});

	jQuery('#multiple-locations-trigger').trigger('click');
}

function addLgnLat(form, lat, lng) {
	var latitude_input = form.find('input[name=latitude]');

	if (latitude_input.length) {
		latitude_input.val(lat);
	} else {
		jQuery('<input>', {
			type: 'hidden',
			name: 'latitude',
			value: lat,
		}).appendTo(form);
	}

	var longitude_input = form.find('input[name=longitude]');

	if (longitude_input.length) {
		longitude_input.val(lng);
	} else {
		jQuery('<input>', {
			type: 'hidden',
			name: 'longitude',
			value: lng,
		}).appendTo(form);
	}

	form.find('[name=search_coord]').val(1);
}

function findCareerAsync(form, searchType) {
	return new Promise((resolve) => {
		if (displayResults) {
			console.log(`Skipping ${searchType} search as results already found.`);
			resolve();
			return;
		}

		let ajaxRequest = findCareer(form, searchType);

		if (ajaxRequest) {
			ajaxRequest.done(() => resolve());
		} else {
			resolve();
		}
	});
}

function findCareer(form, searchType) {
	if (displayResults) {
		console.log(`Skipping ${searchType} search as results already found.`);
		return null;
	}

	var filtersVal = jQuery(form).serializeArray();
	const filtersObj = filtersVal.reduce((acc, f) => {
		if (f.value) {
			acc[f.name] = acc[f.name] ? acc[f.name] + ',' + f.value : f.value;
		}
		return acc;
	}, {});

	if (
		jQuery(document).find('#cms_search').length &&
		(jQuery(document).find('#cms_search').val() == true ||
			jQuery(document).find('#cms_search').val() == 'true')
	) {
		location = 'cms';
	}

	if (
		jQuery(document).find('#combined_search').length &&
		(jQuery(document).find('#combined_search').val() == true ||
			jQuery(document).find('#combined_search').val() == 'true')
	) {
		location = 'combined';
	}

	var data = {
		action: 'mw_ajax_find_career',
		nonce: vp_search_vars.nonce,
		filters: filtersObj,
		type: searchType,
		location: location,
	};

	return jQuery.ajax({
		type: 'POST',
		url: vp_search_vars.ajax_url,
		data: data,
		beforeSend: function () {
			jQuery('.o-vacancies-listing__wrapper').addClass('loading');
		},
		success: function (response) {
			console.log(`AJAX request completed for ${searchType}`);

			if (response.success) {
				console.log(`Careers found: ${response.data.count}`);

				if (response.data.count || searchType === 'name') {
					displayResults = true;
				}

				jQuery('.o-vacancies-listing__wrapper').replaceWith(
					response.data.html
				);
			} else {
				alert('No results');
			}
		},
	});
}

(function ($) {
	$(document).on('click', '#current-location', function () {
		getLocation($('#career-search'));
	});

	$(document).on('submit', '#career-search', async function (e) {
		e.preventDefault();

		displayResults = false;

		var that = $(this),
			term = that.find('[name="search_term"]').val() || null,
			search_coord = that.find('[name="search_coord"]').val(),
			search_country = that.find('[name="search_country"]').val();

		if (search && search != term) {
			that.find('[name=search_coord]').val(0);
			search_coord = 0;
		}

		search = term;

		try {
			if(term == null){
				await findCareerAsync(that, 'location');
				if (displayResults) return;

				await findCareerAsync(that, 'location-outside');
				if (displayResults) return;

				await findCareerAsync(that, 'name');
				if (displayResults) return;
			} else if (term != vp_search_vars.your_location && search_coord == 0) {
				await geocodeAddress(term, that, search_country).then(
					async (locations) => {
						if (locations.length > 1) {
							multipleLocations(locations);
						} else {
							await findCareerAsync(that, 'location');
							if (displayResults) return;

							await findCareerAsync(that, 'location-outside');
							if (displayResults) return;

							await findCareerAsync(that, 'name');
							if (displayResults) return;
						}
					}
				);
			} else {
				await findCareerAsync(that, 'location');
				if (displayResults) return;

				await findCareerAsync(that, 'location-outside');
				if (displayResults) return;
			}
		} catch (error) {
			await findCareerAsync(that, 'name');
		}
		
	});

	$(document).on('click', '#trigger-career-load-more', function (e) {
		e.preventDefault();

		var careerListings = $(document).find(
			'.o-vacancies-single-listing:not(.active)'
		);

		for (let i = 0; i < careerListings.length; i++) {
			if (i < 10) {
				careerListings.eq(i).addClass('active');
			}
		}

		if (
			!$(document).find('.o-vacancies-single-listing:not(.active)').length
		) {
			$('#trigger-career-load-more').hide();
		}

		// Remove focus from the clicked element
		$(this).blur();
	});

	$('.m__job-listings .add-select2').each(function () {
		var current = $(this);

		current.select2({
			minimumResultsForSearch: 11,
			dropdownParent: $(this).closest('.m__job-listings-field'),
			placeholder: $(this).data('placeholder-placeholder-text'),
			allowClear: true,
			closeOnSelect: true
		});

		current.on('change', function () {
			updatePlaceholder(current);
		});

		updatePlaceholder(current);
	});

	function updatePlaceholder(current) {
		let selectedValues = current.val();
		let select2Container = current.next('.select2-container');
		let defaultPlaceholder = current.data('placeholder-text'); 
		let multiplePlaceholder = current.data('placeholder-text-multiple'); 

		if(defaultPlaceholder && multipleLocations) {
			select2Container.addClass('select2-container--custom');
		}

		if (!selectedValues || selectedValues.length === 0) {
			select2Container.attr('data-placeholder-text', defaultPlaceholder).removeClass('multi-selected');
		} else if (selectedValues.length > 1) {
			select2Container.attr('data-placeholder-text-multiple', multiplePlaceholder).addClass('multi-selected');
		} else {
			let selectedText = current.find('option[value="' + selectedValues[0] + '"]').text();
			select2Container.attr('data-placeholder-text', selectedText).removeClass('multi-selected');
		}
	}


	$(document).on('click', '.location-item', function (e) {
		e.preventDefault();

		jQuery('.reveal-overlay').trigger('click');

		var long = $(this).attr('data-lng'),
			lat = $(this).attr('data-lat'),
			location = $(this).text(),
			form = $('#career-search');

		addLgnLat(form, lat, long);
		form.find('[name=search_term]').val(location).change();
		search = false;

		form.trigger('submit');
	});
})(jQuery);
